
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import {  httpOptionsDefault } from "../../../../core/_shared/constants";
import { CreditCardModel, PersonalDataModel } from "../../../../core/_shared/models/credit-card.model";
import { PaymentResult } from "../../../../core/_shared/models/PaymentResult";
import { Scheme } from "../../../../core/_shared/models/Scheme";
import { DbTable } from "../db-table";
import { WebApiService } from "../../WebApiService";

export class DbAdminSchemes extends DbTable<Scheme> {

    getPaymentMethods(): any {
      throw new Error("Method not implemented.");
    }
        constructor(private http: HttpClient, private webApi : WebApiService) {
          super(http,webApi, "adminSchemes");
      }
    
  
      updateAutomationOn(schemeId: number, value: boolean): Promise<any> {
  
          let body = {
              automationOn : value
          };
  
      return this._http.post(this.webApi.GetApiAddress() + `/${this._controllerName}/updateAutomationOn/${schemeId}`,body,
       httpOptionsDefault)    
      .toPromise().then();
    }
  
  
    cancel(schemeId: number): any {
      return this._http.get(this.webApi.GetApiAddress() + `/${this._controllerName}/cancelScheme/${schemeId}`, httpOptionsDefault)
      .pipe(
          map(result => {
  
  
              return result;
          }
  
          ),
          catchError(error => {
  
              return error;
          })
      )
      .toPromise().then((result) => {
  
  
          return result;
      });
    }
  
      pay(schemeId: number): Promise<PaymentResult> {
  
  
          return this._http.get(this.webApi.GetApiAddress() + `/${this._controllerName}/payScheme/${schemeId}`, httpOptionsDefault)
              .pipe(
                  map(result => {
  
  
                      return result;
                  }
  
                  ),
                  catchError(error => {
  
                      return error;
                  })
              )
              .toPromise().then((result:PaymentResult) => {
  
  
                  return result;
              });
      }
  
      create(scheme: Scheme, creditCard: CreditCardModel, personalData: PersonalDataModel): Promise<Scheme> {
  
          let body = { scheme: scheme, creditCard: creditCard, personalData: personalData };
  
          console.log(body);
  
  
          return this._http.post(this.webApi.GetApiAddress() + `/${this._controllerName}/create`, body, httpOptionsDefault)
              .pipe(
                  map(result => {
  
  
                      return result;
                  }
  
                  ),
                  catchError(error => {
  
                      return error;
                  })
              )
              .toPromise().then((result:Scheme) => {
                  return result;
              });
  
      }
  }